<template>
  <HeadlineComponent>Helfer mit Schichten</HeadlineComponent>
  <h1 class="small">Insgesamt: {{usersWithShifts.length}}</h1>
  <div class="row">
    <div>
      <div>
        <div v-for="u of usersWithShifts" :key="u.id">{{u.full_name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from "@/services/user.service.js";
import {mapActions} from "pinia";
import {useAlertsStore} from "@/stores/alerts.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
    name: "UsersWithShiftsView",
    data() {
        return {
            user: [],
        };
    },
    methods: {
        ...mapActions(useAlertsStore, { addAlert: "add" })
    },
    computed: {
        usersWithShifts() {
            return this.user.slice().filter(u => u.shifts && u.shifts.length && u.role === 1);
        }
    },
    async beforeRouteEnter(to, from, next) {
        let user = [];
        try {
            let response = await userService.index(true);
            user = response.data;
        }
        catch (e) {
            if (e) {
                Sentry.captureException(e);
                useAlertsStore().add("danger", "Es ist was unerwartetes schief gegangen..");
                window.scrollTo(0, 0);
            }
        }
        next(vm => {
            vm.user = user;
        });
    },
    components: { HeadlineComponent }
}
</script>

<style scoped>

</style>